import {
    call,
    put,
    all,
    takeEvery
  } from "redux-saga/effects";
  import { GET_ACTIVE_PROMO_EVENT} from "./actionTypes";
  import { getActivePromoEventSuccess} from "./actions";
  import { makeAjax, url } from "../../helpers/global_helper";
  
  function* getPromotionEventData() {
    try {
      
      const response = yield call(
        makeAjax,
        url.DPWD_API.listPlayerActivePromotion, [], url.DPWD_MS_EXT
      );
      if (response.status == 'SUCCESS') {
        yield all([
          put(getActivePromoEventSuccess({ response: response.data }))
         
        ]);
      } else {
        // alert
      }
    } catch (error) {
      
      // alert
    }
  }
  
  function* getPromotionEventSaga() {
    yield takeEvery(GET_ACTIVE_PROMO_EVENT, getPromotionEventData);
  }
  
  export default getPromotionEventSaga;